export const GRAPHQL_CLIENT_NAMES = {
  VERD: 'verd',
};
